export const LURES_FETCH_IN_PROGRESS = "LURES_FETCH_IN_PROGRESS";
export const LURES_FETCH_SUCCESS = "LURES_FETCH_SUCCESS";
export const LURES_FETCH_ERROR = "LURES_FETCH_ERROR";
